'use strict';

import React from 'react';
import Header from './HeaderComponent';
import Navigator from './NavigatorComponent';
import {Link} from 'react-router';

import 'styles/Followers.scss';

class FollowersComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="-component">
        我的粉丝
        <Navigator action='left' />
      </div>
    );
  }
}

FollowersComponent.displayName = 'FollowersComponent';
export default FollowersComponent;



// WEBPACK FOOTER //
// ./src/components/FollowersComponent.js